import strFunc from "@/lib/lyg/string";
import RowArea from "./row";

function UseList(props: any) {
  let myProps = {
    xColumnArr: {},
    info_arr: [],
    textbook_arr: [],
    update_use_main_state_by_ajax: (inData: any) => { },
    update_textbook_use_by_ajax: (inData: any) => { },
    open_word_group_result_popup: (inData: any) => { },
    ...props
  };
  let xColumnArr = myProps.xColumnArr;
  let info_arr = myProps.info_arr;
  let textbook_arr = myProps.textbook_arr;

  const get_group_use_list_by_textbook = () => {
    let group_arr: any[] = [];//{'sort':'subject',title:'',arr:[]}
    let subject_name_arr: any[] = [];
    for (let i = 0; i < textbook_arr.length; i++) {
      let textbook_info = textbook_arr[i];
      if (strFunc.is_empty(textbook_info["a_subject"])) {
        continue;
      }
      if (strFunc.str_in_array(textbook_info["a_subject"], subject_name_arr) == -1) {
        subject_name_arr.push(textbook_info["a_subject"]);
        group_arr.push({ sort: 'subject', title: textbook_info["a_subject"], arr: [] });
      }
    }

    for (let g_i = 0; g_i < group_arr.length; g_i++) {
      let group_info = group_arr[g_i];
      for (let j = 0; j < info_arr.length; j++) {
        let use_info = info_arr[j];
        let text_book_info: any = null;
        for (let k = 0; k < textbook_arr.length; k++) {
          if (textbook_arr[k].a_seq == use_info.a_book_seq) {
            text_book_info = textbook_arr[k];
            break;
          }
        }

        if (text_book_info != null && text_book_info["a_subject"] == group_info.title) {
          group_info.arr.push(use_info);
        }
      }
    }

    return group_arr;
  };

  const get_use_list_tags = (inData: any) => {
    let opt_obj = {
      group_info: {},
      ...inData
    };
    let row_info_arr = opt_obj.group_info.arr;
    let list_tags = row_info_arr.map((item: any, idx: number) => {
      let key_str_arr = [];
      for (let key in item) {
        key_str_arr.push(key);
      }

      return (
        <RowArea key={idx}
          row_num={idx}
          xColumnArr={xColumnArr}
          use_info={item}
          textbook_arr={textbook_arr}
          update_use_main_state_by_ajax={myProps.update_use_main_state_by_ajax}
          update_textbook_use_by_ajax={myProps.update_textbook_use_by_ajax}
          open_word_group_result_popup={myProps.open_word_group_result_popup}
        ></RowArea>
      );
    });
    return list_tags;
  };

  const get_group_use_tags = () => {
    let group_arr = get_group_use_list_by_textbook();
    let group_tags = group_arr.map((group_info: any, g_idx: number) => {
      if (group_info.arr.length == 0) {
        return null;
      }
      return (
        <div key={g_idx}>
          <div>{group_info.title}</div>
          <div className="list-table-div">
            <table style={{ width: "auto" }}>
              <colgroup>
                {xColumnArr.x_column_list_arr.map((col: any, idx: number) => {
                  return (
                    <col key={idx} width={col.width + "px"}></col>
                  );
                })}
              </colgroup>
              <thead>
                <tr>
                  {xColumnArr.x_column_list_arr.map((col: any, idx: number) => {
                    return (
                      <th key={idx} >{col.name}</th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {get_use_list_tags({
                  group_info: group_info
                })}
              </tbody>
            </table>
          </div>
        </div>
      );
    });

    return group_tags;
  }

  return (
    <div>
      {get_group_use_tags()}
    </div>
  );
};
export default UseList;